import React from 'react';
import { makerVariant } from '../variant-resolver.tsx';
const BG_URL = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/footer-bg-mkysx44v6bh.png';
const ASSET_URL = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/footer-asset-k6gjdfp0ec9.png';
const LOGO_URL = 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/great-store-logo-8ucwr55jz5i.png';
export const Footer = () => <section data-name="CTA Footer" data-nav-theme="dark" style={{
  backgroundImage: `url(${BG_URL})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  display: 'flex',
  flexDirection: 'column'
}}>
    {/* CTA area */}
    <div data-name="CTA Content" className="section-content" style={{
    maxWidth: '1360px',
    width: '100%',
    margin: '0 auto',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '200px',
    paddingBottom: '80px',
    flex: 1
  }}>
      <div className="cta-row" style={{
      display: 'flex',
      alignItems: 'center',
      gap: '32px'
    }}>
        {/* Left column — title + button */}
        <div data-name="CTA Copy" className="cta-copy" style={{
        width: '56%',
        flexShrink: 0
      }}>
          <h2 className="section-title" style={{
          fontSize: makerVariant('footerTitleFontSize', 'clamp(52px, 7vw, 92px)'),
          lineHeight: 1.05,
          color: '#FCFAF6',
          margin: 0,
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400
        }}>
            Your customers
            <br />
            are ready. Your
            <br />
            <span>store </span>
            <em style={{
            fontFamily: 'Instrument Serif, serif',
            fontStyle: 'italic',
            fontWeight: 400
          }}>
              should be too.
            </em>
          </h2>

          <div className="cta-btn-wrapper" style={{
          marginTop: '48px'
        }}>
            <a href="/book-a-demo" style={{
            display: 'inline-block',
            backgroundColor: '#FCFAF6',
            color: '#091717',
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400,
            fontSize: '16px',
            borderRadius: '999px',
            padding: '12px 24px',
            textDecoration: 'none',
            transition: 'background-color 0.2s ease'
          }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(252,250,246,0.85)'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#FCFAF6'} data-tracking-id="btn-0536d4e627810319">
              Get your store agent-ready
            </a>
          </div>
        </div>

        {/* Right column — asset */}
        <div data-name="CTA Visual" className="cta-visual" style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
          <img src={ASSET_URL} alt="Store UI mockup" loading="lazy" decoding="async" style={{
          maxWidth: '630px',
          width: '100%',
          objectFit: 'contain',
          display: 'block'
        }} />
        </div>
      </div>
    </div>

    {/* Footer strip */}
    <div data-name="Footer Strip" style={{
    width: '100%',
    borderTop: '1px solid rgba(252, 250, 246, 0.12)'
  }}>
      <div className="section-content footer-strip-inner" style={{
      maxWidth: '1360px',
      margin: '0 auto',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '32px',
      paddingBottom: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
        {/* Left — logo + by maker */}
        <div data-name="Footer Logo" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
          <img src={LOGO_URL} alt="GreatStore" loading="lazy" style={{
          height: '28px',
          objectFit: 'contain'
        }} />
          <a href="https://www.maker.co/" target="_blank" rel="noopener noreferrer" style={{
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          fontSize: '20px',
          color: 'rgba(252, 250, 246, 0.7)',
          textDecoration: 'none'
        }} onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.textDecoration = 'underline'} onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.textDecoration = 'none'} data-tracking-id="link-5e6c140ced018d1d">
            By Maker
          </a>
        </div>

        {/* Center — social links */}
        <div data-name="Footer Social" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '32px'
      }}>
          {([['LinkedIn', 'https://www.linkedin.com/company/maker/posts/?feedView=all'], ['X / Twitter', 'https://x.com/maker']] as const).map(([label, href]) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="font-sans text-base hover:opacity-70 transition-opacity" style={{
          color: '#FCFAF6',
          textDecoration: 'none',
          background: 'transparent',
          border: 'none',
          padding: 0,
          cursor: 'pointer'
        }} data-tracking-id={`link-1bc2f270d4de1950_${label}`}>
              {label}
            </a>)}
        </div>

        {/* Right — copyright */}
        <span data-name="Copyright" style={{
        fontFamily: 'Instrument Sans, sans-serif',
        fontWeight: 400,
        fontSize: '16px',
        color: 'rgba(252, 250, 246, 0.7)',
        textAlign: 'right'
      }}>
          © 2026 Maker. All rights reserved.
        </span>
      </div>
    </div>
  </section>;